import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Typography, Form, Button, Popover, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { setCookie, getDefaultNav } from "../../../utils/helper";
import LoginTemplate from "./LoginTemplate";
import { api } from "../../../services/api";
import { useForm } from "react-hook-form";
import { InputField, InputPassword } from "../../atoms/FormElement";

const { Text, Paragraph } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [loginStatus, setLoginStatus] = useState(false);
  const [loginStatus1, setLoginStatus1] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [tabkey, setTabkey] = React.useState("1");
  const navigate = useNavigate();

  const location = useLocation();
  const { pathname, search } = location.state || {
    pathname: null,
    search: null,
  };

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  let userInfo = JSON.parse(window.localStorage.getItem("login-response"));

  useEffect(() => {
    if (userInfo?.accessToken) {
      navigate(
        getDefaultNav(userInfo?.defaultMenu) ||
          userInfo?.menuList?.data[0]?.value ||
          "/request-access"
      );
    }
  }, []);

  const onFinish = async (values) => {
    setLoginStatus(false);
    setLoading(true);

    let user = values.username;
    if (values.username) {
      user = user.toLowerCase();
    } else {
      user = values.phone;
    }

    const postJson = {
      email: user.toLowerCase(),
      password: values.password,
    };

    try {
      let result = await api.login(postJson);
      window.localStorage.setItem("login-response", JSON.stringify(result));
      window.localStorage.setItem(
        "companyCodes",
        JSON.stringify(result?.companyCodes)
      );
      setCookie("carsTaxiUser", true, new Date(10 || result?.exp).getDate());
      const afterLoginRoute = await sessionStorage.getItem("afterLoginRoute");
      await sessionStorage.removeItem("afterLoginRoute");
      setTimeout(() => {
        navigate(
          afterLoginRoute ||
            getDefaultNav(result?.defaultMenu) ||
            "/request-access"
        );
      }, 1400);
    } catch (error) {
      setLoading(false);
      const { response } = error;
      if (response?.data?.error) {
        setErrorMessage(response?.data?.error);
        if (response?.data?.message.search("password") > 0) {
          setLoginStatus(true);
        } else {
          setLoginStatus1(true);
        }
      } else {
        setLoginStatus(false);
        setLoginStatus1(false);
        message.error(response?.data?.message);
      }
    }
  };

  const handleSSOLogin = async () => {
    window.localStorage.setItem("sso-login", JSON.stringify({ isValid: true }));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/auth-transfer", { state: { sso: "init" } });
    }, 1400);
  };

  return (
    <LoginTemplate load={loading}>
      <Row gutter={[24, 24]}>
        <Col
          span={24}
          onClick={() => {
            const login = JSON.parse(localStorage.getItem("login-response"));
            console.log("pages1", login);
          }}
        >
          <h2 className="signin_heading">Sign in with your account</h2>
        </Col>
        <Col span={24}>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={handleSubmit(onFinish)}
          >
            <>
              <Popover
                placement="right"
                content={
                  <Text type="danger">
                    <InfoCircleOutlined /> {errorMessage}
                  </Text>
                }
                onVisibleChange={() => setLoginStatus1(false)}
                trigger="click"
                visible={loginStatus1}
              >
                <InputField
                  fieldname="username"
                  control={control}
                  initValue=""
                  iProps={{
                    placeholder: "Email",
                    size: "large",
                    prefix: <UserOutlined className="site-form-item-icon" />,
                  }}
                  rules={{
                    pattern: {
                      value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                      message: "Enter valid Email Address",
                    },
                    required: "Please enter Email Address",
                  }}
                  validate={errors.username && "error"}
                  validMessage={errors.username && errors.username.message}
                />
              </Popover>
              <Popover
                placement="right"
                content={
                  <Text type="danger">
                    <InfoCircleOutlined /> {errorMessage}
                  </Text>
                }
                onVisibleChange={() => setLoginStatus(false)}
                trigger="click"
                visible={loginStatus}
              >
                <InputPassword
                  fieldname="password"
                  control={control}
                  initValue=""
                  iProps={{
                    placeholder: "Password",
                    size: "large",
                    prefix: <LockOutlined className="site-form-item-icon" />,
                  }}
                  rules={{
                    pattern: {
                      message: "Please enter correct password",
                    },
                    required: "Please enter password",
                  }}
                  validate={errors.password && "error"}
                  validMessage={errors.password && errors.password.message}
                />
              </Popover>
            </>

            {/* <Form.Item name="remember" valuePropName="checked" noStyle>
              <label>
                <input type="checkbox" />
                Remember me
              </label>
            </Form.Item> */}

            {/* <Link to="/forgot-password" className="login-form-forgot">
              Forgot password?
            </Link> */}

            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
              >
                Sign in
              </Button>
            </Form.Item>
            <div className="or-sso">OR</div>
            <Button
              type="default"
              onClick={handleSSOLogin}
              className="login-form-button sso-button"
              size="large"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                >
                  <title>MS-SymbolLockup</title>
                  <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                  <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                  <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                  <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                </svg>
              }
            >
              Sign in with Microsoft
            </Button>
          </Form>
        </Col>
        <Col className="donthave_acc">
          {/* <h3>Don't have an account yet? <Link to="/signup">Sign up here.</Link></h3> */}
        </Col>
        <Col span={24}>
          <Paragraph className="copyright">Copyright © 2024</Paragraph>
        </Col>
      </Row>
    </LoginTemplate>
  );
};

export default Login;
